import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, HStack, useColorModeValue } from '@chakra-ui/react';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const [currentLang, setCurrentLang] = useState(i18n.language);
  const buttonBg = useColorModeValue('white', 'gray.800');
  const activeButtonBg = useColorModeValue('gray.100', 'gray.700');
  const activeTextColor = useColorModeValue('gray.900', 'white');
  const inactiveTextColor = useColorModeValue('gray.500', 'gray.400');
  const buttonBorder = useColorModeValue('gray.200', 'gray.600');

  useEffect(() => {
    // Update the current language when it changes
    setCurrentLang(i18n.language);
  }, [i18n.language]);

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    // localStorage is handled automatically by the language detector
  };

  // Helper function to get the base language code
  const getBaseLanguage = (lang) => lang.split('-')[0];

  // Check if a language is active
  const isLanguageActive = (lang) => {
    const baseCurrentLang = getBaseLanguage(currentLang);
    return baseCurrentLang === lang;
  };

  return (
    <HStack spacing={2}>
      <Button
        size="sm"
        bg={isLanguageActive('en') ? activeButtonBg : buttonBg}
        color={isLanguageActive('en') ? activeTextColor : inactiveTextColor}
        onClick={() => changeLanguage('en')}
        _hover={{
          bg: isLanguageActive('en') ? activeButtonBg : 'gray.50',
          transform: 'translateY(-1px)',
        }}
        px={2}
        minW="40px"
        borderWidth="1px"
        borderColor={buttonBorder}
        transition="all 0.2s"
      >
        🇬🇧
      </Button>
      <Button
        size="sm"
        bg={isLanguageActive('fr') ? activeButtonBg : buttonBg}
        color={isLanguageActive('fr') ? activeTextColor : inactiveTextColor}
        onClick={() => changeLanguage('fr')}
        _hover={{
          bg: isLanguageActive('fr') ? activeButtonBg : 'gray.50',
          transform: 'translateY(-1px)',
        }}
        px={2}
        minW="40px"
        borderWidth="1px"
        borderColor={buttonBorder}
        transition="all 0.2s"
      >
        🇫🇷
      </Button>
    </HStack>
  );
};

export default LanguageSwitcher; 